import { ReactNode } from 'react';

interface NavSectionItemHeaderProps {
  title: string;
  subtitle: ReactNode;
}
export const NavSectionItemHeader = ({ title, subtitle }: NavSectionItemHeaderProps) => {
  return (
    <>
      <h2 className="u-fs-4 u-bold">{title}</h2>
      <h3 className="mt-1 mb-4">{subtitle}</h3>
    </>
  );
};
